import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=55416a6c&scoped=true&"
import script from "./customer-list.vue?vue&type=script&lang=js&"
export * from "./customer-list.vue?vue&type=script&lang=js&"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=55416a6c&scoped=true&lang=css&"
import style1 from "./customer-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55416a6c",
  null
  
)

export default component.exports